<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row>
          <h2 class="purple bold">Professores</h2>
          <h3 v-if="count" class="tags_count">{{ count }}</h3>
        </b-row>
      </b-col>

      <b-col class="text-right" v-if="canEdit">
        <b-button
          class="btn large blue"
          :to="{
            name: 'novo-professor',
          }"
          >Registrar novo professor</b-button
        >
      </b-col>
    </b-row>
    <b-row class="mt-50">
      <b-col md="3">
        <SelectCycles v-model="cycle" :callback="callbackCycles" />
        <span class="clear-field" v-if="this.cycle != null" @click="clearCycles"
          >Limpar filtro</span
        >
      </b-col>
      <b-col md="4">
        <b-form-group label="Área do Conhecimento">
          <multiselect
            v-model="selectedSubject"
            :options="subjectsOptions"
            :multiple="true"
            placeholder="Selecione as áreas do conhecimento"
            label="designation"
            track-by="subject_id"
            selectLabel=""
            :disabled="!cycle"
            @input="callbackSubjects"
          >
            <span slot="noResult">Nada encontrado</span>
          </multiselect>
        </b-form-group>
        <span
          class="clear-field"
          v-if="this.selectedSubject && this.selectedSubject.length > 0"
          @click="clearSubject"
          >Limpar filtro</span
        >
      </b-col>
      <b-col md="2">
        <b-form-group label="Status">
          <multiselect
            v-model="selectedStatus"
            :options="statusOptions"
            :multiple="false"
            placeholder="Todos"
            label="label"
            track-by="value"
            selectLabel=""
            @input="callbackActive"
          >
            <span slot="noResult">Nada encontrado</span>
          </multiselect>
        </b-form-group>
        <span
          class="clear-field"
          v-if="this.active != null"
          @click="clearActive"
          >Limpar filtro</span
        >
      </b-col>
      <b-col md="3">
        <b-form-group label="Buscar Professor">
          <b-input-group-prepend>
            <b-form-input
              type="search"
              placeholder="Digite aqui"
              v-model="searchTitle"
              v-on:keyup.enter="
                page = 1;
                getList();
              "
            ></b-form-input>
            <b-input-group-text
              class="clear-fields"
              v-if="
                searchTitle != '' ||
                cycle != null ||
                (selectedSubject && selectedSubject.length > 0) ||
                active != null
              "
              v-b-tooltip.hover
              title="Limpar Pesquisa"
            >
              <b-icon icon="x" @click="clearFields" />
            </b-input-group-text>
          </b-input-group-prepend>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-container class="list-top" fluid>
          <b-row
            class="header-list-teacher"
            v-if="teachers.length > 0 && isRequestSend"
          >
            <b-col md="2">
              <p class="bold">Nome</p>
            </b-col>
            <b-col :md="canEdit ? 3 : 6">
              <p class="bold">Área do Conhecimento</p>
            </b-col>
            <b-col md="3">
              <p class="bold" style="text-align: center">Ciclo</p>
            </b-col>
            <b-col v-if="canEdit">
              <p class="bold">Ativo</p>
            </b-col>
            <b-col style="text-align: left" v-if="canEdit">
              <p class="bold">Editar senha</p>
            </b-col>
            <b-col v-if="canEdit">
              <p style="text-align: center" class="bold">Editar</p>
            </b-col>
            <b-col v-if="canEdit">
              <p class="bold">Apagar</p>
            </b-col>
            <b-col v-if="!canEdit" style="text-align: center">
              <p class="bold">Visualizar</p>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid>
          <b-row
            align-v="center"
            class="list-teacher"
            v-for="teacher in teachers"
            v-bind:key="teacher.User.id"
          >
            <b-col md="2" class="name">
              <p class>{{ teacher.User.name }}</p>
            </b-col>
            <b-col :md="canEdit ? 3 : 6" class="disciplines">
              <p class="name">
                {{ teacher.Subjects }}
              </p>
            </b-col>

            <b-col md="3" class="cycles">
              <p
                class="tagss"
                v-for="cycle in teacher.Cycles"
                v-bind:key="cycle.id"
              >
                {{ cycle.name }}
              </p>
            </b-col>

            <b-col class="status" v-if="canEdit">
              <b-form-checkbox
                switch
                v-if="teacher.is_active"
                v-model="teacher.is_active"
                @input="updateStatus(teacher.id, false)"
              ></b-form-checkbox>
              <b-form-checkbox
                switch
                v-else
                v-model="teacher.is_active"
                @input="updateStatus(teacher.id, true)"
              ></b-form-checkbox>
            </b-col>

            <b-col
              class="editar-senha"
              style="text-align: center"
              v-if="canEdit"
            >
              <a
                @click="() => setTeacherPassword(teacher, teacher.id)"
                v-b-modal.edit-password
              >
                <LockIcon />
              </a>
            </b-col>

            <b-col v-if="canEdit" style="text-align: center">
              <router-link
                :to="{
                  name: 'perfil-professor',
                  params: {
                    id: teacher.id,
                  },
                }"
              >
                <EditIcon />
              </router-link>
            </b-col>

            <b-col v-if="canEdit" style="text-align: center">
              <a href v-on:click.prevent="exclude(teacher.id)">
                <DeleteIcon />
              </a>
            </b-col>

            <b-col v-if="!canEdit" style="text-align: center">
              <router-link
                :to="{
                  name: 'perfil-professor-visualizar',
                  params: { id: teacher.id },
                }"
              >
                <ViewIcon />
              </router-link>
            </b-col>
          </b-row>

          <b-row
            align-v="center"
            class="list-teacher"
            v-if="teachers.length <= 0 && isRequestSend"
          >
            <b-col>Nenhum resultado encontrado</b-col>
          </b-row>
          <b-row align-v="center" class="list-teacher" v-if="!isRequestSend">
            <b-col>Carregando</b-col>
          </b-row>
          <b-row
            class="align-center"
            v-else-if="count > perPage && isRequestSend"
          >
            <b-pagination
              v-model="page"
              :per-page="perPage"
              :total-rows="count"
              @change="changePage"
              aria-controls="teachersList"
              last-text
              first-text
            >
              <template #prev-text>
                <LeftArrowIcon class="left" />
              </template>
              <template #next-text>
                <LeftArrowIcon />
              </template>
            </b-pagination>
          </b-row>

          <TeacherEditPassword :teacher="teacherToPassword" />
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import DataService from "@/services/teachers.service";
import DeleteIcon from "@/components/svg/DeleteIcon.vue";
import EditIcon from "@/components/svg/EditIcon.vue";
import ViewIcon from "@/components/svg/ViewIcon.vue";
import LeftArrowIcon from "@/components/svg/LeftArrowIcon.vue";
import LockIcon from "@/components/svg/LockIcon.vue";
import SelectCycles from "@/components/inputs/SelectCycles.vue";
import TeacherEditPassword from "@/components/modals/TeacherEditPassword.vue";
import httpRda from "../../../http-rda";

export default {
  name: "professores",

  components: {
    EditIcon,
    ViewIcon,
    LockIcon,
    LeftArrowIcon,
    SelectCycles,
    TeacherEditPassword,
    DeleteIcon,
  },

  data() {
    return {
      teacherToPassword: {},

      teachers: [],
      User: [],
      teacher: {
        id: "",
      },

      descOrder: false,
      isRequestSend: false,

      cycle: null,
      subject: null,
      searchTitle: "",
      active: 1,

      page: 1,
      count: 0,
      perPage: 20,
      cycle_select: null,
      subjectsOptions: [],
      selectedSubject: [],
      statusOptions: [
        { value: -1, label: "Todos" },
        { value: 1, label: "Ativo" },
        { value: 0, label: "Inativo" },
      ],
      selectedStatus: { value: 1, label: "Ativo" },
      breadcrumb: [
        {
          text: "Comunidade",
          href: "/comunidade",
        },
        {
          text: "Professores",
          href: "/professores",
          active: true,
        },
      ],
    };
  },

  methods: {
    getRequestParams(searchTitle, page, perPage, subject, cycle, active) {
      let params = {};

      if (searchTitle) {
        params["search"] = searchTitle;
      }

      if (page) {
        params["page"] = page;
      }

      if (perPage) {
        params["limit"] = perPage;
      }

      if (subject) {
        params["subjects"] = Array.isArray(subject)
          ? subject.join(",")
          : subject;
      }

      if (cycle) {
        params["cycles"] = cycle;
      }

      if (active !== null && active !== undefined && active !== -1) {
        params["active"] = active;
      }

      return params;
    },

    async getList() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page,
        this.perPage,
        this.subject,
        this.cycle,
        this.active
      );

      const queryParams = {};
      if (this.searchTitle) queryParams.search = this.searchTitle;
      if (this.page && this.page !== 1) queryParams.page = this.page;
      if (this.cycle) queryParams.cycle = this.cycle;
      if (this.subject) {
        queryParams.subject = Array.isArray(this.subject)
          ? this.subject.join(",")
          : this.subject;
      }
      if (this.active !== null && this.active !== undefined) {
        queryParams.active = this.active;
      }

      this.$router.replace({ query: queryParams }).catch(() => {});

      await httpRda
        .get("/teachers-opt", { params })
        .then((response) => {
          this.teachers = response.data.teachers.map((teacher) => {
            return {
              ...teacher,
              Subjects: teacher.Subjects.map((subject) => subject.designation).join(", "),
            };
          });
          this.count = response.data.count;
          this.isRequestSend = true;
        })
        .catch((error) => {
          return error;
        });
    },

    async getSubjects(cycleId) {
      if (!cycleId) {
        this.subjectsOptions = [];
        return;
      }

      try {
        const response = await httpRda.get("/subjects-select", {
          params: { cycleId },
        });

        if (response.data && response.data.subjects) {
          this.subjectsOptions = response.data.subjects.map((item) => ({
            subject_id: item.subject_id,
            designation: item.subject_designation,
          }));
        } else {
          this.subjectsOptions = [];
        }
      } catch (error) {
        this.subjectsOptions = [];
      }
    },

    exclude(id) {
      this.$swal
        .fire({
          title: "Tem certeza?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await DataService.delete(id);
              this.$swal
                .fire("Excluído!", "Professor foi excluído.", "success")
                .then((response) => {
                  this.getList();
                  return response.data;
                });
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel excluir!",
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error.response;
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel excluir!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        });
    },

    updateStatus(id, status) {
      var data = {
        id: id,
        is_active: status,
      };
      DataService.update(id, data)
        .then((response) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: `Status atualizado com sucesso!`,
          });

          return response.data;
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel atualizar!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        });
    },

    orderName() {
      this.descOrder = !this.descOrder;
    },

    async callbackCycles({ id }) {
      this.cycle = id !== -1 ? id : null;
      this.cycle_select = id;
      this.page = 1;
      this.subject = null;
      this.selectedSubject = [];
      this.subjectsOptions = [];

      if (this.cycle) {
        await this.getSubjects(this.cycle);
      }

      this.getList();
    },

    callbackSubjects(selected) {
      this.subject =
        selected && selected.length > 0
          ? selected.map((item) => item.subject_id)
          : null;
      this.page = 1;
      this.getList();
    },

    clearSubject() {
      this.subject = null;
      this.selectedSubject = [];
      this.page = 1;
      this.getList();
    },

    callbackActive(selected) {
      this.active = selected ? selected.value : null;
      this.page = 1;
      this.getList();
    },

    changePage(page) {
      this.page = page;
      this.getList();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    clearFields() {
      this.searchTitle = "";
      this.cycle = null;
      this.subject = null;
      this.selectedSubject = [];
      this.active = 1;
      this.selectedStatus = { value: 1, label: "Ativo" };
      this.page = 1;
      this.getList();
    },

    clearActive() {
      this.active = null;
      this.selectedStatus = { value: -1, label: "Todos" };
      this.page = 1;
      this.getList();
    },

    clearCycles() {
      this.cycle = null;
      this.subject = null;
      this.selectedSubject = [];
      this.subjectsOptions = [];
      this.page = 1;
      this.getList();
    },

    setTeacherPassword(teacher) {
      this.teacherToPassword = teacher;
    },
  },

  async created() {
    const query = this.$route.query;

    this.searchTitle = query.search || "";
    this.page = Number(query.page) || 1;
    this.cycle = query.cycle ? Number(query.cycle) : null;
    this.cycle_select = query.cycle ? Number(query.cycle) : null;
    this.active = query.active !== undefined ? Number(query.active) : 1;

    if (this.active === 1) {
      this.selectedStatus = { value: 1, label: "Ativo" };
    } else if (this.active === 0) {
      this.selectedStatus = { value: 0, label: "Inativo" };
    } else {
      this.selectedStatus = { value: -1, label: "Todos" };
    }

    if (query.subject) {
      const subjectIds = query.subject.includes(",")
        ? query.subject.split(",").map(Number)
        : [Number(query.subject)];
      this.subject = subjectIds;
    }

    if (this.cycle) {
      await this.getSubjects(this.cycle);

      if (this.subject && this.subjectsOptions.length > 0) {
        this.selectedSubject = this.subjectsOptions.filter((opt) =>
          this.subject.includes(opt.subject_id)
        );
      }
    }

    this.getList();
  },

  computed: {
    ...mapGetters({
      user: "auth/getAuthData",
    }),

    canEdit() {
      if (!this.user.role) return false;
      return ["coordinator", "admin"].some((role) =>
        this.user.role.includes(role)
      );
    },
  },

  watch: {
    "$route.query": {
      handler(query) {
        this.searchTitle = query.search || "";
        this.page = Number(query.page) || 1;
        this.cycle = query.cycle ? Number(query.cycle) : null;
        this.cycle_select = query.cycle ? Number(query.cycle) : null;
        this.active = query.active !== undefined ? Number(query.active) : 1;

        if (this.active === 1) {
          this.selectedStatus = { value: 1, label: "Ativo" };
        } else if (this.active === 0) {
          this.selectedStatus = { value: 0, label: "Inativo" };
        } else {
          this.selectedStatus = { value: -1, label: "Todos" };
        }

        if (query.subject) {
          const subjectIds = query.subject.includes(",")
            ? query.subject.split(",").map(Number)
            : [Number(query.subject)];
          this.subject = subjectIds;

          if (this.subjectsOptions.length > 0) {
            this.selectedSubject = this.subjectsOptions.filter((opt) =>
              this.subject.includes(opt.subject_id)
            );
          }
        } else {
          this.subject = null;
          this.selectedSubject = [];
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";
.tags_count {
  background-color: #68c5b7;
  border-radius: 3px;
  color: #fff;
  margin-left: 10px;
  padding: 3px 10px;
  height: max-content;
}
.list-top {
  margin-top: 30px;
  margin-bottom: 30px;
}
.text-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.list-teacher {
  background-color: $white;
  border: 1px solid $grey5;
  border-radius: 10px;
  margin-bottom: 15px;
  min-height: 80px;
  &:hover {
    border-color: transparent;
    background-image: linear-gradient($white, $white),
      radial-gradient(circle at top left, $orange, $purple);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }
  p {
    margin: 0;
  }
  .disciplines {
    .name {
      display: inline-block;
      line-height: 22px;
      &:last-child {
        .comma {
          display: none;
        }
      }
    }
  }
  .cycles {
    display: flex;
    flex-wrap: wrap;
    .tagss {
      background-color: $blue;
      border-radius: 5px;
      color: $white;
      font-weight: $bold;
      line-height: 28px;
      margin: 3px 12px 3px 0;
      width: 90px !important;
      padding: 0 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }
}

.order-grid-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 25px;
  .order-list {
    align-items: center;
    color: $grey4;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    margin: 0 9px;
    svg {
      margin-left: 15px;
      transition: all 0.15s;
    }
    &.desc {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  .order-style {
    border: 1px solid transparent;
    background-image: linear-gradient($white, $white),
      radial-gradient(circle at top left, $orange, $purple);
    background-origin: border-box;
    background-clip: content-box, border-box;
    border-radius: 5px;
    display: flex;
    margin: 0 0 0 9px;
    button {
      background: $gradient1;
      border: 0;
      line-height: 46px;
      width: 48px;
      svg {
        path {
          fill: $white;
        }
      }
      &.active {
        background-color: $white;
        background: $white;
        border-radius: 5px;
        svg {
          path {
            fill: url(#paint0_linear);
          }
        }
      }
    }
  }
}

.multiselect--disabled {
  opacity: 0.6;
  cursor: not-allowed;

  .multiselect__select {
    background-color: #ededed;
  }

  .multiselect__tags {
    background-color: #ededed;
    pointer-events: none;
  }
}
</style>
